"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.IrisAgoraEventHandler = void 0;
const NATIVE_RTC = __importStar(require("@iris/native-rtc"));
const AgoraTranslate_1 = require("../util/AgoraTranslate");
class IrisAgoraEventHandler {
    constructor(engine) {
        this._engine = engine;
        // onAutoplayFailed = this.onAutoplayFailed.bind(this);
        // AgoraRTC.onCameraChanged = this.onCameraChanged.bind(this);
        // AgoraRTC.onMicrophoneChanged = this.onMicrophoneChanged.bind(this);
        // AgoraRTC.onPlaybackDeviceChanged = this.onMicrophoneChanged.bind(this);
    }
    onAutoplayFailed() {
        this._engine.rtcEngineEventHandler.onError_d26c0fd(NATIVE_RTC.ERROR_CODE_TYPE.ERR_NOT_READY, 'auto play failed');
    }
    onCameraChanged(info) {
        let deviceId = info.device.deviceId;
        let deviceType = NATIVE_RTC.MEDIA_DEVICE_TYPE.VIDEO_CAPTURE_DEVICE;
        let deviceState = AgoraTranslate_1.AgoraTranslate.DeviceState2NATIVE_RTCMEDIA_DEVICE_STATE_TYPE(info.state);
        this._engine.rtcEngineEventHandler.onVideoDeviceStateChanged_976d8c3(deviceId, deviceType, deviceState);
        // this._engine.rtcEngineEventHandler.onMediaDeviceChanged(deviceType);
    }
    onMicrophoneChanged(info) {
        let deviceId = info.device.deviceId;
        let deviceType = NATIVE_RTC.MEDIA_DEVICE_TYPE.AUDIO_RECORDING_DEVICE;
        let deviceState = AgoraTranslate_1.AgoraTranslate.DeviceState2NATIVE_RTCMEDIA_DEVICE_STATE_TYPE(info.state);
        this._engine.rtcEngineEventHandler.onAudioDeviceStateChanged_976d8c3(deviceId, deviceType, deviceState);
        // this._engine.rtcEngineEventHandler.onMediaDeviceChanged(deviceType);
    }
    onPlaybackDeviceChanged(info) {
        let deviceId = info.device.deviceId;
        let deviceType = NATIVE_RTC.MEDIA_DEVICE_TYPE.AUDIO_PLAYOUT_DEVICE;
        let deviceState = AgoraTranslate_1.AgoraTranslate.DeviceState2NATIVE_RTCMEDIA_DEVICE_STATE_TYPE(info.state);
        this._engine.rtcEngineEventHandler.onAudioDeviceStateChanged_976d8c3(deviceId, deviceType, deviceState);
        // this._engine.rtcEngineEventHandler.onMediaDeviceChanged(deviceType);
    }
    release() {
        this._engine.globalState.AgoraRTC.onAutoplayFailed = undefined;
        this._engine.globalState.AgoraRTC.onCameraChanged = undefined;
        this._engine.globalState.AgoraRTC.onMicrophoneChanged = undefined;
        this._engine.globalState.AgoraRTC.onPlaybackDeviceChanged = undefined;
    }
}
exports.IrisAgoraEventHandler = IrisAgoraEventHandler;
